export default "__VITE_ASSET__jPzqwpVv__"